import { ControlEventType, ControlPropertyType } from '../../../enums';

export const TextareaPropertyType = {
  ...ControlPropertyType,
  Rows: 'rows',
  Cols: 'cols',
  Resize: 'Resize',
  Maxlength: 'maxLength',
  Minlength: 'minLength',
  FillType: 'fillType',
  Required: 'Required',
  HasCharLimitHint: 'hasCharLimitHint',
};

export const TextAreaResizeType = {
  None: 'resize-none',
  Horizontal: 'resize-horizontal',
  Vertical: 'resize-vertical',
  Both: 'resize-both',
};

export const TextareaEventType = {
  ...ControlEventType,
  Input: 'input',
};
